import Vue from 'vue'
import Router from 'vue-router'

import auth from './auth'

import commonRoutes from './routes/common'
import reviewerRoutes from './routes/reviewer'
import adminRoutes from './routes/admin'

if (!process || process.env.NODE_ENV !== 'test') {
  Vue.use(Router)
}

const router = new Router({
  routes: [
    ...commonRoutes,
    ...reviewerRoutes,
    ...adminRoutes,
  ]
})

auth(router)

export default router
